import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Observable, merge, of } from 'rxjs';
import { auditTime, catchError, map, startWith, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface ReceivingQueueState {
  count: number | null;
  unavailable: boolean;
}

@Injectable({ providedIn: 'root' })
export class ReceivingQueueService {
  constructor(private readonly http: HttpClient, private readonly socket: Socket) {}

  watch(warehouseId?: number): Observable<ReceivingQueueState> {
    return merge(
      of('refresh'),
      this.socket.fromEvent('receiving_queue_changed').pipe(map(() => 'refresh')),
      this.socket.fromEvent('connect').pipe(map(() => 'refresh')),
      this.socket.fromEvent('disconnect').pipe(map(() => 'offline'))
    ).pipe(
      // One cheap count query per burst; a newer event cancels an outdated response.
      auditTime(150),
      switchMap((event) => event === 'offline'
        ? of({ count: null, unavailable: true })
        : this.http.get<{ count: number }>(`${environment.BACKEND}/doc/receiving/reconciliation-count`, {
            params: warehouseId == null ? {} : { warehouseId: String(warehouseId) }
          }).pipe(
            map(({ count }) => ({ count, unavailable: false })),
            catchError(() => of({ count: null, unavailable: true }))
          )),
      startWith({ count: null, unavailable: false })
    );
  }
}
